import ArticleModel from '@/dex-shared/models/ArticleModel';
import ContentModel from '@/dex-shared/models/ContentModel';

export default {
  articleById: (state: any, getters: any) => (articleId: number) => {
    let article = state.articles[articleId];
    if (article) {
      return new ArticleModel(article, getters);
    } else {
      return {};
    }
  },
  contentsByArticleId: (state: any, getters: any) => (articleId: number) => {
    return Object.values(state.contents)
      .map((content: any) => new ContentModel(content, getters))
      .filter((content: ContentModel) => content.articleId === articleId);
  },
};
